import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
    constructor(private navigationService: NavigationService) { }

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Настройки');
    }
}
